var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1673 9.46161L17.134 7.13661L17.4173 4.06161L14.409 3.37828L12.834 0.711609L10.0007 1.92828L7.16732 0.711609L5.59232 3.36994L2.58398 4.04494L2.86732 7.12828L0.833984 9.46161L2.86732 11.7866L2.58398 14.8699L5.59232 15.5533L7.16732 18.2116L10.0007 16.9866L12.834 18.2033L14.409 15.5449L17.4173 14.8616L17.134 11.7866L19.1673 9.46161ZM8.40898 13.3949L5.24232 10.2199L6.47565 8.98661L8.40898 10.9283L13.284 6.03661L14.5173 7.26994L8.40898 13.3949Z",
    fill: "#3889FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.1403cda1.svg";
export { ForwardRef as ReactComponent };